/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row5_LinearInputs */

const en_mk_cmp_row5_linear = /** @type {(inputs: Mk_Cmp_Row5_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const id_mk_cmp_row5_linear = /** @type {(inputs: Mk_Cmp_Row5_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Mk_Cmp_Row5_LinearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row5_linear = /** @type {((inputs?: Mk_Cmp_Row5_LinearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row5_LinearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row5_linear(inputs)
	return en_mk_cmp_row5_linear(inputs)
});